import { CustomCellRendererProps } from 'ag-grid-react';
import { useTranslation } from 'react-i18next';
import { DocumentFamily } from '@cas/config/documents';
import { ReactElement, useMemo } from 'react';
import BadgeList from '../badge-list/BadgeList';

export function DocumentProductFamiliesCellRenderer({
  value,
}: CustomCellRendererProps<{ productFamilies: DocumentFamily[] }, DocumentFamily[]>): ReactElement {
  const { t } = useTranslation();

  const orderedItems = useMemo<string[]>(() => {
    if (Array.isArray(value)) {
      const translated: string[] = value.map(family => t('DocProductFamily.' + family));

      // Ensure in alphabetical order
      return translated.sort((a, b) => a[1].localeCompare(b[1]));
    }

    return [];
  }, [value, t]);

  return <BadgeList items={orderedItems} />;
}

export default DocumentProductFamiliesCellRenderer;
